export { buildClassMap } from './buildClassMap';

export { getIcon, registerIcons, registerIconAlias, unregisterIcons, setIconOptions } from './icons';

export { getIconClassName } from './getIconClassName';
export type { IIconRecord, IIconSubset, IIconSubsetRecord, IIconOptions } from './icons';
